import url from "../../../module/fetch.tsx";
import { PageContent } from "../../../components/Elements/Elements.tsx";
import PageTitle from "../../../components/Elements/PageTitle/PageTitle.tsx";
import { IconBookCopy } from "../../../components/Icon/Icon.tsx";
import QueryTableWithFilter from "../../../components/Table/QueryTableWithFilter.tsx";
import { PreviewColumn } from "../../../components/Table/columns.tsx";
import TYPE_RESSOURCE from "../../../enum/TypeRessource.tsx";
import EditRessource from "./EditRessource.tsx";
import FiltreRessources, {
  filterValuesToVariable,
  initialFilterValues,
} from "./FiltreRessources.tsx";
import styles from "./GestionRessources.module.css";

const GestionRessources = () => {
  return (
    <>
      <PageTitle icon={<IconBookCopy />} title="Gestion des contenus" />
      <PageContent>
        <QueryTableWithFilter
          idName="ressources"
          query={url`/api/ressource/`}
          filterComponent={<FiltreRessources />}
          initialFilterValues={initialFilterValues}
          filterValuesToVariable={filterValuesToVariable}
          columns={[
            {
              Header: "Code",
              accessor: "ressourceCode",
              sortField: "ressourceCode",
            },
            {
              Header: "Titre",
              accessor: "ressourceLibelle",
              sortField: "ressourceLibelle",
            },
            {
              Header: "Type de contenu",
              accessor: "typeRessourceLibelle",
              sortField: "typeRessourceLibelle",
            },
            {
              Header: "Nom du fichier",
              accessor: "ressourceNomFichier",
              sortField: "ressourceNomFichier",
            },
            {
              Header: "Action",
              accessor: ({
                ressourceCode,
                typeRessourceCode,
                ressourcePrivee,
                ressourceId,
                ressourceLibelle,
                ressourceDescription,
                typeRessourceId,
                ressourceTelechargeable,
              }: {
                ressourceCode: string;
                typeRessourceCode: TYPE_RESSOURCE;
                ressourcePrivee: boolean;
                ressourceId: string;
                ressourceLibelle: string;
                ressourceDescription: string;
                typeRessourceId: string;
                ressourceTelechargeable: boolean;
              }) => {
                return {
                  ressourceCode,
                  typeRessourceCode,
                  ressourcePrivee,
                  ressourceId,
                  ressourceLibelle,
                  ressourceDescription,
                  typeRessourceId,
                  ressourceTelechargeable,
                };
              },
              Cell: (row: any) => {
                return (
                  <>
                    <div className={styles.buttonsDiv}>
                      <PreviewColumn
                        ressourceCode={row.value.ressourceCode}
                        ressourceType={row.value.typeRessourceCode}
                        ressourcePrivee={row.value.ressourcePrivee}
                      />
                      <EditRessource
                        ressourceId={row.value.ressourceId}
                        ressourceLibelle={row.value.ressourceLibelle}
                        ressourceDescription={row.value.ressourceDescription}
                        typeRessourceId={row.value.typeRessourceId}
                        typeRessource={row.value.typeRessource}
                        file={row.value.file}
                        previewFile={row.value.previewFile}
                        ressourceTelechargeable={
                          row.value.ressourceTelechargeable
                        }
                      />
                    </div>
                  </>
                );
              },
              width: 100,
            },
          ]}
        />
      </PageContent>
    </>
  );
};

export default GestionRessources;
